import { ConstructAdvancedAbortController } from './constructor';
import { ADVANCED_ABORT_CONTROLLER_PRIVATE } from './privates';
import { AdvancedAbortSignalAbort } from './advanced-abort-signal/functions';
import { IsAdvancedAbortSignal } from './advanced-abort-signal/constructor';
import { EventsObservable } from '../../notifications/observables/events/events-observable/public';
import { AbortReason } from '../reason/built-in/abort-reason';
import { $timeout } from './advanced-abort-signal/snipets';
import { TimeoutReason } from '../reason/built-in/timeout-reason';
export function AdvancedAbortControllerGetSignal(instance) {
    return instance[ADVANCED_ABORT_CONTROLLER_PRIVATE].signal;
}
export function AdvancedAbortControllerAbort(instance, reason) {
    AdvancedAbortSignalAbort(instance[ADVANCED_ABORT_CONTROLLER_PRIVATE].signal, reason);
}
export function AdvancedAbortControllerFromAbortSignals(_constructor, signals) {
    const instance = new _constructor();
    const _signals = signals.filter((signal, index) => {
        if (signal === void 0) {
            return false;
        }
        else if ((signal instanceof AbortSignal) || IsAdvancedAbortSignal(signal)) {
            return true;
        }
        else {
            throw new TypeError(`Expected AbortSignal, AdvancedAbortSignal or undefined at arguments #${index} of AdvancedAbortController.fromAbortSignals`);
        }
    });
    const abort = (signal) => {
        instance.abort(('reason' in signal)
            ? signal.reason
            : new AbortReason(`AbortSignal aborted`));
    };
    for (let i = 0, l = _signals.length; i < l; i++) {
        const signal = _signals[i];
        if (signal.aborted) {
            abort(signal);
            return instance;
        }
    }
    const signalObservers = _signals.map((signal) => {
        const observable = ((signal instanceof AbortSignal)
            ? new EventsObservable(signal)
            : signal);
        return observable.addListener('abort', () => {
            clear();
            abort(signal);
        });
    });
    const clear = () => {
        for (let i = 0, l = signalObservers.length; i < l; i++) {
            signalObservers[i].deactivate();
        }
        signalListener.deactivate();
    };
    const signalListener = instance.signal.addListener('abort', clear);
    for (let i = 0, l = signalObservers.length; i < l; i++) {
        signalObservers[i].activate();
    }
    signalListener.activate();
    return instance;
}
export function AdvancedAbortControllerTimeout(_constructor, timeout, signal) {
    const controller = new _constructor();
    $timeout(() => {
        controller.abort(new TimeoutReason());
    }, timeout, AdvancedAbortControllerFromAbortSignals(_constructor, (signal === void 0)
        ? [controller.signal]
        : [controller.signal, signal]).signal);
    return controller;
}
export class AdvancedAbortController {
    static fromAbortSignals(...signals) {
        return AdvancedAbortControllerFromAbortSignals(this, signals);
    }
    static timeout(timeout, signal) {
        return AdvancedAbortControllerTimeout(this, timeout, signal);
    }
    constructor() {
        ConstructAdvancedAbortController(this);
    }
    get signal() {
        return AdvancedAbortControllerGetSignal(this);
    }
    abort(reason) {
        return AdvancedAbortControllerAbort(this, reason);
    }
}
//# sourceMappingURL=implementation.js.map